module.exports = __webpack_public_path__ + "static/media/codelco.1666ed30.png";